import {PropertyPath} from "@firefly/fly-defter";
import useShallowMemo from "../effect/useShallowMemo";


function useDocumentMeta(property: PropertyPath): string | null {

    return useShallowMemo(() => {
        const key = Array.isArray(property) ? property : [property];
        const element = document.querySelector(`meta[property="${key.join(':')}"]`);
        const value = element?.getAttribute('content');
        return value??null;
    }, [property])
}

export default useDocumentMeta;